module.exports = __webpack_public_path__ + "static/logo-431ebb53dabfbb1f36fedca7f7c09ee2.png";